import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Homepage from './pages/homepage/homepage.component';
import Diensten from './pages/diensten/diensten.component';
import OverOns from './pages/over_ons/over_ons.component';
import OnsWerk from './pages/ons_werk/ons_werk.component';
import NavBar from './components/molecules/navbar/navbar.component';
import ArrowToTop from './components/atoms/arrow-to-top/arrow-to-top.component';
import PageNotFound from './pages/404/page_not_found.component';

import Credits from './pages/credits/credits.component';
import TermsAndConditions from './pages/terms-and-conditions/terms-and-conditions.component';
import ContactCard from './components/organisms/contact-card/contact-card.component';

const App = () => {
  return (
    <>
      <ContactCard />
      <ArrowToTop />
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/over-ons" element={<OverOns />} />
          <Route path="/diensten" element={<Diensten />} />
          <Route path="/ons-werk" element={<OnsWerk />} />
          <Route path="/credits" element={<Credits />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
